export default __webpack_public_path__ + "static/media/73.a33f8ea7.jpg";